export default [
  {
    path: '/schedule-vacations',
    component: () => import('@/views/schedule-vacation/ScheduleVacations.vue'),
    name: 'ScheduleVacationList',
    meta: {
      title: 'Danh sách ngày nghỉ',
      auth: true,
    },
  },
]
